import React, {Component} from 'react';

import styles from './Checkbox.less';

export default class Checkbox extends Component {
	render() {
		const {children, className, refNode, ...props} = this.props;
		const {
			checkbox: checkboxClass,
			checkbox__inputBox: inputBoxClass,
			checkbox__contentBox: contentBoxClass,
			checkbox__input: inputClass
		} = styles;

		return (
			<label className={[className, checkboxClass].join(' ')}>
				<span className={inputBoxClass}>
					<input type='checkbox' className={inputClass} ref={refNode} {...props} />
				</span>

				{
					children ? (
						<span className={contentBoxClass}>{children}</span>
					) : (null)
				}
			</label>
		);
	}
}